import JwtMypassService from './jwtMypassService';

export default JwtMypassService;
